var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"interactive-tour",class:{'ongoing': _vm.tourStarted},attrs:{"data-lastid":_vm.messageID,"data-user":_vm.username,"stock":_vm.currentStock}},[_c('div',{staticClass:"tutorial-start",attrs:{"title":"View tutorial"},on:{"click":_vm.startTour}},[_vm._v("🔍")])])
}
var staticRenderFns = []

export { render, staticRenderFns }